import { BLOG_POSTS } from "@/content/blogPosts";
import { BLOG_POSTS_UR } from "@/content/blogPostsUr";

export const BLOG_I18N = {
    en: {
        posts: BLOG_POSTS,
        base: "/blog",
        other: "/ur/blog",
        otherLabel: "اردو",
        otherClass: "font-urdu",
        badge: "Hair care blog",
        h1: "Hair care tips for Pakistani hair",
        intro: "Practical, honest guides on hair fall, rosemary and scalp care — written for our water, weather and food.",
        title: "Hair Care Blog Pakistan | Hair Fall Tips & Rosemary Guides · Resham Drops",
        description: "Hair care articles for Pakistani hair: rosemary oil vs serum, hair fall after pregnancy, dandruff and hair fall, and the best diet for hair growth.",
        read: "Read article",
        mins: (n) => `${n} min read`,
        back: "All articles",
        faq: "Quick answers",
        ctaTitle: "Try PCSIR certified rosemary hair serum",
        ctaSub: "Lightweight, non-sticky · Cash on delivery across Pakistan",
        ctaBtn: "Shop the serum",
        more: "Keep reading",
        locale: "en-PK",
    },
    ur: {
        posts: BLOG_POSTS_UR,
        base: "/ur/blog",
        other: "/blog",
        otherLabel: "English",
        otherClass: "font-sans",
        badge: "ہیئر کیئر بلاگ",
        h1: "پاکستانی بالوں کے لیے ہیئر کیئر ٹپس",
        intro: "بال گرنے، روزمیری اور اسکالپ کیئر پر آسان اور سچی گائیڈز — ہمارے پانی، موسم اور غذا کو مدنظر رکھ کر لکھی گئی۔",
        title: "ہیئر کیئر بلاگ | بال گرنے کا علاج اور روزمیری گائیڈ · ریشم ڈراپس",
        description: "روزمیری تیل یا سیرم، ڈلیوری کے بعد بال گرنا، خشکی اور بال گرنا، اور بال اگانے کے لیے بہترین غذا — اردو میں مکمل مضامین۔",
        read: "مضمون پڑھیں",
        mins: (n) => `${n} منٹ`,
        back: "تمام مضامین",
        faq: "مختصر جوابات",
        ctaTitle: "PCSIR سے تصدیق شدہ روزمیری ہیئر سیرم آزمائیں",
        ctaSub: "ہلکا، بغیر چکنائی · پورے پاکستان میں کیش آن ڈلیوری",
        ctaBtn: "سیرم خریدیں",
        more: "مزید پڑھیں",
        locale: "ur-PK",
    },
};

export const urduProps = (lang) =>
    lang === "ur" ? { dir: "rtl", lang: "ur", style: { letterSpacing: 0 }, className: "font-urdu text-right" } : { className: "" };
